export function isLabelmapActorEntry(entry) {
    return entry.excludeFromFidelity === true;
}
